exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.md-card[data-v-8bac8b1e] {\r\n  max-width: 600px;\r\n  margin: 4px;\r\n  display: block;\r\n  vertical-align: top;\n}\r\n", ""]);

// exports
